import React from 'react';
import './LoiTermFormTabStrip.scss';
import { LoiTermFormTab, LoiTermFormTabDefinition, LoiTermFormTabs } from '../../../../../../slices/marketplace/loi-form/loi-term-form-tabs';

export interface LoiTermFormTabStripProps {
    activeTab: LoiTermFormTab;
    onChange: (tab: LoiTermFormTab) => void;
    tabsWithErrors?: Set<LoiTermFormTab>;
    tabs?: LoiTermFormTabDefinition[];
}

export const LoiTermFormTabStrip = (props: LoiTermFormTabStripProps) => {
    const { activeTab, onChange, tabsWithErrors, tabs = LoiTermFormTabs } = props;

    return (
        <div className="RRT__container loi-term-form-tabs">
            <div className="RRT__tabs body-tabs">
                {tabs.map((tab) => {
                    const isSelected = activeTab === tab.id;
                    const hasError = tabsWithErrors?.has(tab.id) ?? false;
                    const classNames = ['RRT__tab'];
                    if (isSelected) {
                        classNames.push('RRT__tab--first', 'RRT__tab--selected');
                    }
                    if (hasError) {
                        classNames.push('error-tab');
                    }
                    return (
                        <div
                            key={tab.id}
                            className={classNames.join(' ')}
                            onClick={() => onChange(tab.id)}>
                            {tab.label}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
